module.exports = __webpack_public_path__ + "img/Jasper - Idea.38004743.png";